<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="学校名称">
          <a-input
            class="form-cell"
            type="text"
            v-model="queryParam.schoolName"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="地区"
          class="form-oper"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-cascader
            v-if="$store.state.common.address.length > 0"
            class="form-cell"
            :options="$store.state.common.address"
            placeholder="请选择"
            changeOnSelect
            v-model="queryParam.addressSelect"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          />
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchSchool()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper" v-if="isOper">
      <a-button type="primary" icon="plus" @click="$refs.schoolForm.init('add')"
        >新建</a-button
      >
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="schoolList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      :rowKey="getRowKey"
    >
      <span slot="address" slot-scope="text, record">
        <template>
          <span
            >{{ record.provinceId | codeFilter }}{{ record.cityId | codeFilter
            }}{{ record.districtId | codeFilter }}</span
          >
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text, record">
        <template v-if="isOper">
          <a @click="$refs.schoolForm.init('update', record)">修改</a>
          <a-divider type="vertical" />
          <a @click="deleteSchool(record)">删除</a>
        </template>
      </span>
    </a-table>
    <school-form-modal
      v-if="isOper"
      ref="schoolForm"
      @addSchool="addSchool"
      @updateSchool="updateSchool"
    ></school-form-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import school from '../../api/school'

import SchoolFormModal from './SchoolFormModal'

import { getDate } from '../../utils/date'
import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '学校名称',
    dataIndex: 'schoolName',
  },
  {
    title: '负责人名称',
    dataIndex: 'nickname',
  },
  {
    title: '教育局',
    dataIndex: 'bureauName',
  },
  {
    title: '代理',
    dataIndex: 'agentName',
  },
  {
    title: '地区',
    dataIndex: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'schoolList',
  data() {
    return {
      schoolList: [], //学校数据
      columns: JSON.parse(JSON.stringify(columns)), //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
      isOper: false, //是否具有操作权限
    }
  },
  components: {
    CTable,
    SchoolFormModal,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then((res) => {
        //只有代理才有权限
        let roleId = res.accRole.id.toString()
        if (['1'].indexOf(roleId) != -1) {
          this.isOper = true
        } else {
          this.isOper = false
          this.columns.length = this.columns.length - 1
        }
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getSchoolList(obj)
    },

    //新增一个学校
    addSchool(school) {
      this.schoolList.unshift(school)
    },

    //修改一个学校
    updateSchool(school) {
      for (let i in this.schoolList) {
        if (this.schoolList[i].id == school.id) {
          this.$set(this.schoolList, i, school)
        }
      }
    },

    //删除学校
    deleteSchool(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          school.deleteSchool(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteSchoolData(self.schoolList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteSchoolData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //查询学校
    searchSchool() {
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      this.getSchoolList(obj)
    },

    //学校列表
    getSchoolList(params) {
      this.loading = true
      school.getSchoolList(params).then((res) => {
        console.log('当前的学校列表是', res.data.list)
        this.schoolList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
      let arr = []
      if (this.queryParam.provinceId) {
        arr[0] = this.queryParam.provinceId
      }
      if (this.queryParam.cityId) {
        arr[1] = this.queryParam.cityId
      }
      if (this.queryParam.districtId) {
        arr[2] = this.queryParam.districtId
      }
      this.queryParam.addressSelect = arr
    } else {
      this.queryParam = {}
    }
    this.getSchoolList(this.queryParam)
    this.judgeIsOper()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.search-inner {
  margin-bottom: 20px;
}
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
</style>
